
  import addthis from 'addthis-snippet';
  import { ADDTHIS } from '@/constants/addthis';
  import { monthlyCost } from '@/scripts/current';

  export default {
    props: {
      article: { type: Object, required: true }
    },
    data () {
      return {
        C0004: false
      };
    },
    computed: {
      onetrustCompliant () {
        return this.article.video_id && this.C0004;
      },
      bundle () {
        return (this.product && this.product.klass === 'commsbundle') ? this.product : null;
      },
      card () {
        return (this.product && this.product.klass === 'card') ? this.product : null;
      },
      current () {
        if (this.product && this.product.klass === 'current') {
          const cost = monthlyCost(this.product, this.search);
          return { ...this.product, ...{ cost } };
        }
        return null;
      },
      mortgageComparison () {
        if (this.product && this.product.klass === 'mortgage') {
          return this.$store.getters['products/getComparison'];
        }
        return null;
      },
      plan () {
        return (this.product && this.product.klass === 'energy-plan') ? this.product : null;
      },
      product () {
        return this.$store.getters['products/get'];
      },
      relatedProductComponent () {
        if (this.product && this.product.klass) {
          const key = {
            commsbundle: 'comms',
            current: 'currents',
            'energy-plan': 'energy',
            mortgage: 'mortgages'
          }[this.product.klass.toLowerCase()];
          return `products-${key}-result`;
        }
        return null;
      },
      search () {
        return this.$store.getters['search/get'];
      }
    },
    mounted () {
      const vm = this;
      window.OptanonWrapper = function () {
        vm.oneTrustActiveGroupCheck();
      };
      addthis(ADDTHIS.config, ADDTHIS.share);
      const $relatedProducts = this.$el.querySelectorAll('.result');
      const $content = this.$el.querySelector('.article-content');
      const $descendants = this.$el.querySelectorAll('.article-content > *');
      // if only 1 relatedProducts insert after 2nd
      if ($relatedProducts.length === 1) {
        $content.insertBefore($relatedProducts[0], $descendants[Math.floor($descendants.length / 3)]);
      } else {
        $relatedProducts.forEach((rp, index) => {
          $content.insertBefore(rp, $descendants[index + 2]);
        });
      }
    },
    methods: {
      oneTrustActiveGroupCheck () {
        this.C0004 = window.OnetrustActiveGroups.includes('C0004');
      }
    }
  };
